<article
  class="inscription-lieu-examen-form"
  :class="articleClasses"
>
  <div class="inscription-lieu-examen-form__messages">
    <transition
      name="fade-fast"
      mode="out-in"
    >
      <template v-if="inscriptionLieuExamen.isSituationAccommodement">
        <m-message :state="MMessageState.Information">
          <p v-html="$i18next.t('modules.inscription-lieu-examen.form.InscriptionLieuExamenForm.message.accommodement.content')" />
        </m-message>
      </template>
    </transition>
    <transition
      name="fade-fast"
      mode="out-in"
    >
      <template v-if="inscriptionLieuExamen.isEnregistrer && !stateChanged">
        <m-message :state="MMessageState.Success">
          <p v-html="$i18next.t('modules.inscription-lieu-examen.form.InscriptionLieuExamenForm.message.saved.content', inscriptionLieuExamen)" />
        </m-message>
      </template>
    </transition>
    <transition
      name="fade-fast"
      mode="out-in"
    >
      <template v-if="inscriptionLieuExamen.afficherMessageDateLimiteInscription && inscriptionLieuExamen.horodateDateLimiteInscription">
        <m-message :state="MMessageState.Warning">
          <p v-html="$i18next.t('modules.inscription-lieu-examen.form.InscriptionLieuExamenForm.message.date_limite_inscription.content', inscriptionLieuExamen.horodateDateLimiteInscription)" />
        </m-message>
      </template>
    </transition>
    <transition
      name="fade-fast"
      mode="out-in"
    >
      <template v-if="inscriptionLieuExamen.conflitsHoraire && inscriptionLieuExamen.conflitsHoraire.length > 0">
        <m-message :state="MMessageState.Error">
          <template v-if="inscriptionLieuExamen.conflitsHoraire.length > 1">
            <p v-html="$i18next.t('modules.inscription-lieu-examen.form.InscriptionLieuExamenForm.message.conflits_horaire.content_plural', { exams: generateConflitHoraireExamsLabel(inscriptionLieuExamen) })" />
          </template>
          <template v-else>
            <p v-html="$i18next.t('modules.inscription-lieu-examen.form.InscriptionLieuExamenForm.message.conflits_horaire.content', { exams: generateConflitHoraireExamsLabel(inscriptionLieuExamen) })" />
          </template>
        </m-message>
      </template>
    </transition>
  </div>
  <div class="inscription-lieu-examen-form__content">
    <div class="inscription-lieu-examen-form__informations">
      <div class="inscription-lieu-examen-form__informations-horodates">
        <template v-if="!inscriptionLieuExamen.horodateCampus && !inscriptionLieuExamen.horodateHorsCampus">
          <div class="inscription-lieu-examen-form__informations-horodates--horodate-a-venir">
            <h5>
              {{ $i18next.t('modules.inscription-lieu-examen.form.InscriptionLieuExamenForm.horodates.a_venir.label') }}
            </h5>
            <div class="inscription-lieu-examen-form__chips inscription-lieu-examen-form__chips--top">
              <div class="inscription-lieu-examen-form__chips--chip inscription-lieu-examen-form__chips--type-examen">
                <p>
                  {{ inscriptionLieuExamen.titreTypeExamen }}
                </p>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <template v-if="inscriptionLieuExamen.horodateCampus">
            <div class="inscription-lieu-examen-form__informations-horodates--horodate-campus">
              <div class="inscription-lieu-examen-form__informations-horodates--calendar-preview">
                <p class="inscription-lieu-examen-form__informations-horodates--calendar-preview-day">
                  {{ inscriptionLieuExamen.horodateCampus.journee }}
                </p>
                <p class="inscription-lieu-examen-form__informations-horodates--calendar-preview-numeric-day">
                  {{ inscriptionLieuExamen.horodateCampus.journeeNumerique }}
                </p>
                <p class="inscription-lieu-examen-form__informations-horodates--calendar-preview-month">
                  {{ inscriptionLieuExamen.horodateCampus.mois }}
                </p>
              </div>
              <div>
                <div class="inscription-lieu-examen-form__chips inscription-lieu-examen-form__chips--top">
                  <div class="inscription-lieu-examen-form__chips--chip inscription-lieu-examen-form__chips--type-examen">
                    <p>
                      {{ inscriptionLieuExamen.titreTypeExamen }}
                    </p>
                  </div>
                </div>
                <div class="inscription-lieu-examen-form__informations-horodates--timestamp">
                  <m-icon
                    name="m-svg__clock"
                    size="24px"
                  />
                  <p>
                    {{ inscriptionLieuExamen.horodateCampus.periode }}
                    <template v-if="inscriptionLieuExamen.horodateHorsCampus">
                      <br />
                      <strong class="inscription-lieu-examen-form__informations-horodates--timestamp-description">
                        {{ $i18next.t('modules.inscription-lieu-examen.form.InscriptionLieuExamenForm.horodates.campus.description') }}
                      </strong>
                    </template>
                  </p>
                </div>
              </div>
            </div>
          </template>
          <template v-if="inscriptionLieuExamen.horodateHorsCampus">
            <div class="inscription-lieu-examen-form__informations-horodates--horodate-hors-campus">
              <div class="inscription-lieu-examen-form__informations-horodates--calendar-preview">
                <p class="inscription-lieu-examen-form__informations-horodates--calendar-preview-day">
                  {{ inscriptionLieuExamen.horodateHorsCampus.journee }}
                </p>
                <p class="inscription-lieu-examen-form__informations-horodates--calendar-preview-numeric-day">
                  {{ inscriptionLieuExamen.horodateHorsCampus.journeeNumerique }}
                </p>
                <p class="inscription-lieu-examen-form__informations-horodates--calendar-preview-month">
                  {{ inscriptionLieuExamen.horodateHorsCampus.mois }}
                </p>
              </div>
              <div>
                <template v-if="!inscriptionLieuExamen.horodateCampus">
                  <div class="inscription-lieu-examen-form__chips inscription-lieu-examen-form__chips--top">
                    <div class="inscription-lieu-examen-form__chips--chip inscription-lieu-examen-form__chips--type-examen">
                      <p>
                        {{ inscriptionLieuExamen.titreTypeExamen }}
                      </p>
                    </div>
                  </div>
                </template>
                <div class="inscription-lieu-examen-form__informations-horodates--timestamp">
                  <m-icon
                    name="m-svg__clock"
                    size="24px"
                  />
                  <p>
                    {{ inscriptionLieuExamen.horodateHorsCampus.periode }}
                    <template v-if="inscriptionLieuExamen.horodateCampus">
                      <br />
                      <strong class="inscription-lieu-examen-form__informations-horodates--timestamp-description">
                        {{ $i18next.t('modules.inscription-lieu-examen.form.InscriptionLieuExamenForm.horodates.hors_campus.description') }}
                      </strong>
                    </template>
                    <template v-if="inscriptionLieuExamen.afficherMessageFuseauHoraire">
                      <br />
                      {{ $i18next.t('modules.inscription-lieu-examen.form.InscriptionLieuExamenForm.horodates.fuseau_horaire') }}
                    </template>
                    <template v-if="inscriptionLieuExamen.isAvecCasSpecial">
                      <br />
                      {{ $i18next.t('modules.inscription-lieu-examen.form.InscriptionLieuExamenForm.horodates.accommodement') }}
                    </template>
                  </p>
                </div>
              </div>
            </div>
          </template>
        </template>
      </div>
      <template v-if="isFormAvailable">
        <m-form
          :form-group="formGroup"
          class="inscription-lieu-examen-form__informations-form"
        >
          <div class="inscription-lieu-examen-form__informations-form--title">
            <template v-if="typeInscriptionLieuExamenField">
              <transition
                name="fade-fast"
                mode="out-in"
              >
                <template v-if="isTypeInscriptionLieuExamenLoadingStateActive">
                  <m-progress :indeterminate="true" />
                </template>
                <template v-else>
                  <m-radio-group
                    :label="$i18next.t('modules.inscription-lieu-examen.form.InscriptionLieuExamenForm.form.title')"
                    v-model="typeInscriptionLieuExamenField.value"
                    v-m-control="typeInscriptionLieuExamenField"
                    :error="typeInscriptionLieuExamenField.hasError()"
                    :error-message="typeInscriptionLieuExamenField.errorMessage"
                    @change="onInscriptionLieuExamenUpdate"
                  >
                    <location-svg slot="icon" />
                    <template v-for="typeInscriptionLieuExamen in typesInscriptionLieuExamen">
                      <m-radio :value="typeInscriptionLieuExamen.id">
                        {{ $i18next.t(`modules.inscription-lieu-examen.form.InscriptionLieuExamenForm.form.situations.${typeInscriptionLieuExamen.slug}.label`) }}
                      </m-radio>
                      <transition
                        name="fade-fast"
                        mode="out-in"
                      >
                        <template v-if="typeInscriptionLieuExamen.slug === ITypeInscriptionLieuExamen_SLUGS.CENTRE_EXAMEN && typeInscriptionLieuExamenField.value !== typeInscriptionLieuExamen.id && centreExamenDisabledDropdown">
                          <div class="inscription-lieu-examen-form__informations-form--centre-examen">
                            <m-dropdown
                              :label="$i18next.t(`modules.inscription-lieu-examen.form.InscriptionLieuExamenForm.form.situations.${typeInscriptionLieuExamen.slug}.centre_examen_select.label`)"
                              :placeholder="$i18next.t(`modules.inscription-lieu-examen.form.InscriptionLieuExamenForm.form.situations.${typeInscriptionLieuExamen.slug}.centre_examen_select.placeholder`)"
                              :filterable="true"
                              :error="centreExamenDisabledDropdown.hasError()"
                              :error-message="centreExamenDisabledDropdown.errorMessage"
                              max-width="medium"
                              :disabled="true"
                              :helper-message="$i18next.t(`modules.inscription-lieu-examen.form.InscriptionLieuExamenForm.form.situations.${typeInscriptionLieuExamen.slug}.centre_examen_select.hint`)"
                              @change="onInscriptionLieuExamenUpdate"
                            >
                              <template v-for="city in cities">
                                <m-dropdown-item
                                  :key="city.id"
                                  :label="city.nom"
                                  :value="city.id"
                                />
                              </template>
                            </m-dropdown>
                          </div>
                        </template>
                        <template v-if="typeInscriptionLieuExamen.slug === ITypeInscriptionLieuExamen_SLUGS.CENTRE_EXAMEN && typeInscriptionLieuExamenField.value === typeInscriptionLieuExamen.id && centreExamenDropdown">
                          <div class="inscription-lieu-examen-form__informations-form--centre-examen">
                            <m-dropdown
                              :label="$i18next.t(`modules.inscription-lieu-examen.form.InscriptionLieuExamenForm.form.situations.${typeInscriptionLieuExamen.slug}.centre_examen_select.label`)"
                              :placeholder="$i18next.t(`modules.inscription-lieu-examen.form.InscriptionLieuExamenForm.form.situations.${typeInscriptionLieuExamen.slug}.centre_examen_select.placeholder`)"
                              :filterable="true"
                              v-model="centreExamenDropdown.value"
                              v-m-control="centreExamenDropdown"
                              :error="centreExamenDropdown.hasError()"
                              :error-message="centreExamenDropdown.errorMessage"
                              max-width="medium"
                              :helper-message="$i18next.t(`modules.inscription-lieu-examen.form.InscriptionLieuExamenForm.form.situations.${typeInscriptionLieuExamen.slug}.centre_examen_select.hint`)"
                              @change="onInscriptionLieuExamenUpdate"
                            >
                              <template v-for="city in cities">
                                <m-dropdown-item
                                  :key="city.id"
                                  :label="city.nom"
                                  :value="city.id"
                                />
                              </template>
                            </m-dropdown>
                          </div>
                        </template>
                        <template v-else-if="typeInscriptionLieuExamen.slug === ITypeInscriptionLieuExamen_SLUGS.REPONDANT && typeInscriptionLieuExamenField.value === typeInscriptionLieuExamen.id && villeRepondantField && paysRepondantDropdown">
                          <div class="inscription-lieu-examen-form__informations-form--repondant">
                            <m-textfield
                              class="inscription-lieu-examen-form__informations-form--pays-repondant-select"
                              :label="$i18next.t(`modules.inscription-lieu-examen.form.InscriptionLieuExamenForm.form.situations.${typeInscriptionLieuExamen.slug}.ville_repondant_field.label`)"
                              :placeholder="$i18next.t(`modules.inscription-lieu-examen.form.InscriptionLieuExamenForm.form.situations.${typeInscriptionLieuExamen.slug}.ville_repondant_field.placeholder`)"
                              v-model="villeRepondantField.value"
                              v-m-control="villeRepondantField"
                              :error="villeRepondantField.hasError()"
                              :error-message="villeRepondantField.errorMessage"
                              @input="onInscriptionLieuExamenUpdate"
                            />
                            <m-dropdown
                              class="inscription-lieu-examen-form__informations-form--pays-repondant-select"
                              :label="$i18next.t(`modules.inscription-lieu-examen.form.InscriptionLieuExamenForm.form.situations.${typeInscriptionLieuExamen.slug}.pays_repondant_select.label`)"
                              :placeholder="$i18next.t(`modules.inscription-lieu-examen.form.InscriptionLieuExamenForm.form.situations.${typeInscriptionLieuExamen.slug}.pays_repondant_select.placeholder`)"
                              :filterable="true"
                              v-model="paysRepondantDropdown.value"
                              v-m-control="paysRepondantDropdown"
                              :error="paysRepondantDropdown.hasError()"
                              :error-message="paysRepondantDropdown.errorMessage"
                              @change="onInscriptionLieuExamenUpdate"
                            >
                              <template v-for="country in countries">
                                <m-dropdown-item
                                  :key="country.id"
                                  :label="country.nom"
                                  :value="country.nom"
                                />
                              </template>
                            </m-dropdown>
                            <m-dialog
                              :open="isRepondantInformationsModalOpen"
                              :state="MDialogState.Warning"
                              :width="MDialogWidth.Large"
                              :okLabel="$i18next.t('modules.inscription-lieu-examen.form.InscriptionLieuExamenForm.dialog.repondant_confirmation.button.ok.label')"
                              @cancel="onInformationModalCancelButtonClick"
                            >
                              {{ $i18next.t('modules.inscription-lieu-examen.form.InscriptionLieuExamenForm.dialog.repondant_confirmation.message') }}
                            </m-dialog>
                          </div>
                        </template>
                      </transition>
                    </template>
                  </m-radio-group>
                </template>
              </transition>
            </template>
          </div>
        </m-form>
      </template>
      <template v-else-if="inscriptionLieuExamen.evenement">
        <div>
          <div class="inscription-lieu-examen-form__informations-event">
            <location-svg />
            <template v-if="inscriptionLieuExamen.evenement.messageFacultaire">
              <p v-html="inscriptionLieuExamen.evenement.messageFacultaire" />
            </template>
            <template v-else>
              <p>
                <strong>
                  <template v-if="inscriptionLieuExamen.evenement.nomLieuParent">
                    <span v-html="$i18next.t(`modules.inscription-lieu-examen.form.InscriptionLieuExamenForm.event.label.avec_lieu_parent`, inscriptionLieuExamen.evenement)" />
                  </template>
                  <template v-else-if="inscriptionLieuExamen.evenement.nomLieu">
                    <span v-html="$i18next.t(`modules.inscription-lieu-examen.form.InscriptionLieuExamenForm.event.label.sans_lieu_parent`, inscriptionLieuExamen.evenement)" />
                  </template>
                  <template v-else>
                    <span v-html="$i18next.t(`modules.inscription-lieu-examen.form.InscriptionLieuExamenForm.event.label.sans_lieu`, inscriptionLieuExamen.evenement)" />
                  </template>
                </strong>
                <br />
                <template v-if="inscriptionLieuExamen.evenement.adresse">
                  <span v-html="$i18next.t(`modules.inscription-lieu-examen.form.InscriptionLieuExamenForm.event.description.adresse`, inscriptionLieuExamen.evenement)" />
                </template>
                <template v-else-if="inscriptionLieuExamen.situation && inscriptionLieuExamen.situation.slugTypeInscriptionLieuExamen === ITypeInscriptionLieuExamen_SLUGS.REPONDANT">
                  <span
                    class="inscription-lieu-examen-form__informations-event--warning-adresse"
                    v-html="$i18next.t(`modules.inscription-lieu-examen.form.InscriptionLieuExamenForm.event.description.adresse_repondant`)"
                  />
                </template>
                <template v-else>
                  <span
                    class="inscription-lieu-examen-form__informations-event--warning-adresse"
                    v-html="$i18next.t(`modules.inscription-lieu-examen.form.InscriptionLieuExamenForm.event.description.adresse_non_presente`)"
                  />
                </template>
                <template v-if="inscriptionLieuExamen.evenement.numeroSalle">
                  <br />
                  <span v-html="$i18next.t(`modules.inscription-lieu-examen.form.InscriptionLieuExamenForm.event.description.salle`, inscriptionLieuExamen.evenement)" />
                </template>
              </p>
            </template>
          </div>
          <template v-if="inscriptionLieuExamen.gestionFicheRepondantDisponible">
            <div class="inscription-lieu-examen-form__informations-fiche-repondant">
              <m-button @click="onDisplayGestionFicheRepondantButtonClick">
                {{ $i18next.t('modules.inscription-lieu-examen.form.InscriptionLieuExamenForm.button.fiche_repondant_gestion') }}
              </m-button>
            </div>
          </template>
        </div>
      </template>
    </div>
    <div class="inscription-lieu-examen-form__chips inscription-lieu-examen-form__chips--bottom">
      <div class="inscription-lieu-examen-form__chips--chip inscription-lieu-examen-form__chips--type-examen">
        <p>
          {{ inscriptionLieuExamen.titreTypeExamen }}
        </p>
      </div>
    </div>
  </div>
</article>